import * as React from "react";
import { styled } from "@mui/material";
import { bottomNavigationZIndex } from "fe-common/ui/stacking";
import AddIcon from "@mui/icons-material/Add";
import { ClickAwayListener } from "@mui/material";

//region [[ Styles ]]
const IPHONE_COLOR = "rgba(235,239,240,1)";
const PhonyIphoneBubbleView = styled("div")(({ direction }: { direction?: "up" | "down" }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexFlow: direction === "down" ? "column" : "column-reverse",
  width: "100%",
  zIndex: bottomNavigationZIndex + 1,
  position: "absolute",
  bottom: "0px",
}));

const BubbleText = styled("div")({
  backgroundColor: IPHONE_COLOR,
  borderRadius: "10px",
  padding: "5px 6px",
  display: "flex",
  flexFlow: "row",
  alignItems: "center",
  "& i": {
    margin: "10px",
    color: "gray",
    fontSize: "28px",
    fontFamily: "FontAwesome",
  },
  // TODO: remove once fa-v6 is introduced
  "& i.fa-arrow-up-from-square": {
    position: "relative",
    fontSize: "14px",
    color: "deepskyblue",
  },
  "& i.fa-arrow-up-from-square:before": {
    content: '"\\f096"',
  },
  "& i.fa-arrow-up-from-square:after": {
    left: "15%",
    top: "-40%",
    position: "absolute",
    content: '"\\f176"',
  },
});

const TextContent = styled("div")({
  padding: "10px 3px",
});

const BubbleArrow = styled("div")(({ direction }: { direction: "up" | "down" }) => ({
  height: 0,
  borderRightColor: "transparent",
  borderLeftColor: "transparent",
  borderBottomColor: direction === "down" ? "transparent" : IPHONE_COLOR,
  borderTopColor: direction === "up" ? "transparent" : IPHONE_COLOR,
  borderWidth: "20px",
  borderStyle: "solid",
}));

const PlusIconContainer = styled("div")({
  height: "24px",
  width: "24px",
  borderRadius: "5px",
  display: "flex",
  background: "gray",
  alignItems: "center",
  "& svg": {
    fill: "white",
  },
  justifyContent: "center",
  margin: "10px",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface PhonyIphoneBubbleProps {
  /***
   * @default "down"
   */
  direction?: "up" | "down";
  onClose?: () => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PhonyIphoneBubble = ({ ...props }: PhonyIphoneBubbleProps) => {
  return (
    <ClickAwayListener onClickAway={props.onClose}>
      <PhonyIphoneBubbleView direction={props.direction || "down"}>
        <BubbleText>
          <PlusIconContainer>
            <AddIcon />
          </PlusIconContainer>
          <TextContent>
            Install the webapp on your iPhone: tap{" "}
            <i className="fal fa-arrow-up-from-square" aria-hidden="true" /> and
            then Add to Home Screen
          </TextContent>
        </BubbleText>
        <BubbleArrow direction={props.direction || "down"} />
      </PhonyIphoneBubbleView>
    </ClickAwayListener>
  );
};
